<template>
    <v-flex sm6 xs12 class="my-4">
        <div v-if="content.title" class="headline mb-3">{{ content.title }}</div>
        <ul>
            <li v-for="(link, i) in content.links" :key="i" class="cross_link">
                <linkGreen v-if="!link.hide_link" class="mr-4" @click="link.database_id ? modal_open_wrapper(link) : 'null'">{{ link.title }}</linkGreen>
                <span v-else>{{ link.title }}</span>
            </li>
        </ul>
    </v-flex>
</template> 

<script>
import linkGreen from '@/components/ui/links/styled/link_green.vue';
import {mapGetters, mapMutations, mapActions} from 'vuex';
export default {
  components: {
    linkGreen,
  },
  props: { 
    content: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters('database/modal', [
      'crosslink_detail_modal',
      'current_inner',
    ]),
  },
  methods: {
  ...mapMutations('database/modal', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
      'SET_CURRENT_INNER',
    ]),
    modal_open_wrapper(link) {
      let obj = {type: link.code, id: link.database_id};
      this.OPEN_MODAL(this.crosslink_detail_modal);
      this.SET_CURRENT_INNER(obj);
    },
  }
};
</script>
<style lang="less" scoped>
.cross_link {
    list-style-type: disc;
    margin-left: 20px;
    margin-bottom: 8px;
}
</style>

